import { render, staticRenderFns } from "./ComTab.vue?vue&type=template&id=76e22b3e&scoped=true"
import script from "./ComTab.vue?vue&type=script&lang=js"
export * from "./ComTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e22b3e",
  null
  
)

export default component.exports